module.exports = __webpack_public_path__ + "imgs/OneColorado.e9c6bb9f4e2ac690cab3647be483ebbd.png";